import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { useLocation, useSearchParams } from 'react-router-dom'

import Image from '../ui/Image/Image'
import Card from '../ui/Card/Card'
import HeaderScrollHandler from '../HeaderScrollHandler/HeaderScrollHandler'
import AnimatedImageDescriptionCard from '../AnimatedImageDescriptionCard/AnimatedImageDescriptionCard'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import useHorizontalScroll from '../../hooks/useHorizontalScroll'
import { getImageUrl, isArabic } from '../../utils'
import styles from './ExistingPartnership.module.scss'
import { EXISTING_PARTNERSHIP } from '../../Contansts'

function ExistingPartnership({ widgetData: countries = [], sectionTitle }) {
  const { language } = useLanguage()

  const { scrollRef, scrollLeft, scrollRight, isAtStart, isAtEnd } =
    useHorizontalScroll(200)

  const [searchParams] = useSearchParams()
  const countryCode = searchParams.get('cn')

  const { pathname } = useLocation()
  const path = pathname.split('/')
  const currentSectionPath = path[path.length - 1]

  let searchedCountry = countries[0]
  if (countryCode) {
    let findCountry = countries.find((item) => item.countrycode === countryCode)
    if (findCountry) {
      searchedCountry = { ...findCountry }
    }
  }

  const [selectedCountry, setSelectedCountry] = useState({ ...searchedCountry })
  const selectedCountryRef = useRef(null)

  const handleGA = (country) => {
    if (currentSectionPath === EXISTING_PARTNERSHIP)
      window.gtag('event', 'link_click', {
        link_url: window?.location?.href,
        link_text: country?.countryname,
      })
  }

  const cardClickHandler = (country) => {
    setSelectedCountry({
      ...country,
      partners_subsections: country?.partners_subsections
        ? [...country?.partners_subsections]
        : [],
    })
    handleGA(country)
  }

  useEffect(() => {
    handleGA(selectedCountry)
  }, [])

  useEffect(() => {
    if (selectedCountryRef.current) {
      const element = selectedCountryRef.current
      const bounding = element.getBoundingClientRect()
      const isOutOfViewport =
        bounding.left < 0 ||
        bounding.right >
          (window.innerWidth || document.documentElement.clientWidth)

      if (isOutOfViewport) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        })
      }
    }
  }, [selectedCountry])

  return (
    <div className={styles.container}>
      <div className={styles.topContainer}>
        <HeaderScrollHandler
          scrollLeft={scrollLeft}
          scrollRight={scrollRight}
          isAtStart={isAtStart}
          isAtEnd={isAtEnd}
          // subTitle={sectionTitle}
          className={classNames('page-container', styles.scroll)}
        />
        <div
          ref={scrollRef}
          className={classNames(styles.cardContainer, {
            [styles.arabicCardContainer]: isArabic(language?.code),
          })}
        >
          {countries.map((country) => (
            <Card
              ref={
                country.id === selectedCountry.id ? selectedCountryRef : null
              }
              key={country.countryname + country?.id}
              className={classNames(styles.cardHolder, {
                [styles.active]: country.id === selectedCountry.id,
              })}
              onClickHandler={() => {
                cardClickHandler(country)
              }}
            >
              <Image
                className={styles.countryIcon}
                src={getImageUrl(country.countrylogo)}
                alt={country?.countrylogo?.alternativeText}
              />
              <span>{country.countryname}</span>
            </Card>
          ))}
        </div>
      </div>
      <div
        className={classNames(
          'page-container',
          styles.subSectionCardsContainer
        )}
      >
        {selectedCountry?.partners_subsections?.length ? (
          selectedCountry.partners_subsections.map((info, i) => (
            <AnimatedImageDescriptionCard
              key={'partnersSubsection' + info?.id}
              index={i}
              title={info?.title}
              image={info?.image}
              description={info?.description}
              isAnimated={false}
              infoClassname={styles.animationCardContainer}
            />
          ))
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}

export default ExistingPartnership
